import React, { Component } from "react";

class ComponentNotAvailable extends Component {
  render() {
    // const { label } = this.props;
    return (
      <div>
        {/*<ComponentHeader title={label} />*/}
        {/*<div*/}
        {/*  className={classnames(*/}
        {/*    styles.not_available,*/}
        {/*    styles.flex_container,*/}
        {/*    styles.align_container*/}
        {/*  )}*/}
        {/*>*/}
        {/*  <span className={styles.not_available_span}>*/}
        {/*    <img src={"/img/icons/not-available.svg"} alt={""} />*/}
        {/*    {_("componentNotAvailable")}*/}
        {/*  </span>*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default ComponentNotAvailable;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/ComponentNotAvailable.js